// Mirrors the server-side guard so the request reflects exactly what will be modeled —
// otherwise blanks/dupes/zeros would round-trip and the surfaced scenarios wouldn't match
// what the underwriter actually entered.
export function buildAsIfAopDeds(fieldValues) {
  if (!Array.isArray(fieldValues)) return [];
  const seen = new Set();
  const out = [];
  for (const field of fieldValues) {
    const raw = field && field.amount;
    const n = typeof raw === 'number' ? raw : parseInt(String(raw).trim(), 10);
    if (!Number.isFinite(n) || n <= 0 || seen.has(n)) continue;
    seen.add(n);
    out.push(n);
  }
  return out.sort((a, b) => a - b);
}
